import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-2 sm:space-y-0">
          <div className="text-sm text-gray-500">
            © {currentYear} August CMS. All rights reserved.
          </div>
          <div className="text-sm text-gray-500">
            by <a 
              href="https://simplesmart.com.au" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
            >
              SimpleSmart
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
